import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import lottie from "lottie-web/build/player/lottie_light";
import '../public/js/lite-youtube';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;
window.Swal = Swal;
window.lottie = lottie;

// JavaScript
$(document).ready( function () {
  //scroll top
  $('.back-to-top').click(function(event){
    $("html,body").animate({scrollTop: 0}, 1000);
  });

  // transparent header
  var windowHeight = $(window).height();
  function windowScroll_0_8() {
    if ($(window).scrollTop() > windowHeight*0.8) {
      $('.back-to-top').addClass("is-show");
    } else {
      $('.back-to-top').removeClass("is-show");
    }
  }
  if ($('.product-show-main').length >= 1) {
    var product_show_main_offset = $('.product-show-main').offset().top;
    var product_show_main_height = $('.product-show-main').height();
  }
  function windowScroll_btns_fixed() {
    if ($(window).scrollTop() > product_show_main_offset + product_show_main_height) {
      $('.product-show-btns').addClass("fixed");
    } else {
      $('.product-show-btns').removeClass("fixed");
    }
  }

  $(window).on('scroll', function () {
    windowScroll_0_8();
    if ($(".product-show-btns").length >= 1) {
      windowScroll_btns_fixed();
    }
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function(e) {
    if (window.innerWidth <= 1200) {
      e.preventDefault();
      if ($(this).parent('.header-menu-link').hasClass('active')) {
        $(this).parent('.header-menu-link').removeClass('active');
      } else {
        $(this).parent('.header-menu-link').addClass('active');
      }
    }
  });

  var indexBanner = new Swiper('#indexBanner', {
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    loop: true,
    peed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  // 首頁解決方案產品
  $('.sol-item').on('click', function () {
    var sol_id = $(this).attr('id');
    var sol_html = $("[data-id=" + sol_id + "]").html();
    var product_count = $(this).attr('data-product-count');
    if (product_count == 2) {
      var popup_size = 860;
    } else {
      var popup_size = 452;
    }
    Swal.fire({
      width: popup_size,
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        container: 'swal-sol-products',
      },
      html: sol_html,
    });
  });

  var indexNews = new Swiper('#indexNews', {
    slidesPerView: 3,
    slidesPerView: 10,
    navigation: {
      prevEl: ".index-news-prev",
      nextEl: ".index-news-next",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1000: {
        spaceBetween: 36,
        slidesPerView: 3,
      },
    },
  });

  // 產品輪播
  var productSlide = new Swiper('#productSlide', {
    effect: 'fade',
    speed: 1000,
    navigation: {
      prevEl: ".product-slide-prev",
      nextEl: ".product-slide-next",
    },
  });
  // dropdown
  $('.dropdown-btn').on('click', function () {
    var web_hover = $(this).parent('.dropdown').hasClass('web-hover');
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      if (!web_hover && window.innerWidth > 640) {
        $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
        $('[aria-labelledby=' + id + ']').addClass('is-active');
      }else {
        $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
        $('[aria-labelledby=' + id + ']').addClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '100vh',
            'overflow': 'hidden',
          })
        }
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // tab
  $('.tab[data-tab]').on('click', function () {
    var tabPanes = $(this).data('tabs');
    var ID = $(this).data('tab');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $("[data-tab-panes=" + tabPanes + "]").find("[data-tab-pane=" + ID + "]").addClass('is-active').siblings('.tab-pane').removeClass('is-active');
  });

  // header search
  $('#search_btn').on('click', function () {
    $('#search_popup').addClass('is-active');
  });
  $('.search-popup-close, .search-popup-mask').on('click', function () {
    $('#search_popup').removeClass('is-active');
  });

  // 下載專區
  $('.password-download-item .password').on('click', function(e) {
    if ($(this).attr('href') !== "#") {
      return;
    }
    e.preventDefault();
    const downloadId = $(this).data('download-id');
    const i18nElements = $(this).closest('.password-download-item');
    const swalI18n = i18nElements.data('swal-i18n');
    Swal.fire({
      title: swalI18n.title,
      input: 'password',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: swalI18n.confirm,
      cancelButtonText: swalI18n.cancel,
      showLoaderOnConfirm: true,
      preConfirm: (password) => {
        return fetch(`/downloads/${downloadId}/verify_password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({ password: password })
        })
        .then(response => {
          if (response.ok) {
            Swal.fire({
              icon: 'success',
              title: swalI18n.success,
              text: swalI18n.password_success_text,
              confirmButtonText: swalI18n.confirm,
              willClose: () => {
                location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: swalI18n.error,
              text: swalI18n.password_incorrect
            });
          }
        })
        .catch(error => {
          Swal.showValidationMessage(`請求失敗: ${error}`)
        })
      },
      allowOutsideClick: () => !Swal.isLoading()
    });
  });

  const getFileNameFromDisposition = (contentDisposition) => {
    if (!contentDisposition) return 'download';

    // 先找 filename*=UTF-8''xxxxx 這種格式
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/i);
    if (utf8Match) {
      return decodeURIComponent(utf8Match[1]);
    }

    // fallback 找一般的 filename="..."
    const fallbackMatch = contentDisposition.match(/filename="?([^";\n]+)"?/i);
    if (fallbackMatch) {
      return fallbackMatch[1];
    }

    return 'download';
  };

  // 檔案申請表單
  $('#documentRequestForm').on('submit', function(e) {
    e.preventDefault();
    const form = $(this);
    const i18nElements = form.find('.form-download-item');
    const swalI18n = i18nElements.data('swal-i18n');

    $.ajax({
      url: form.attr('action'),
      method: 'POST',
      data: form.serialize(),
      success: function(response) {
        Swal.fire({
          icon: 'success',
          title: swalI18n.success,
          text: swalI18n.form_success_text,
          confirmButtonText: swalI18n.confirm,
          willClose: () => {
            location.reload();
          }
        });

        form.find('input[type="submit"]').removeAttr('disabled');
      },
      error: function(xhr) {
        const errors = xhr.responseJSON?.errors || [];
        if (errors.length > 0) {
          Swal.fire({
            icon: 'error',
            title: swalI18n.error,
            html: errors.join('<br>')
          });
        } else {
          // 應該會是 validate_cloudflare_turnstile 的錯誤
          Swal.fire({
            icon: 'error',
            title: swalI18n.error,
            text: swalI18n.form_error_text
          });
        }
        // 啟用提交按鈕
        form.find('input[type="submit"]').removeAttr('disabled');
      },
    });
  });

  // YouTube 播放器
  const modal = document.getElementById('youtube-modal');
  const closeBtn = document.querySelector('.close-modal');
  const iframe = document.getElementById('youtube-iframe');

  if (modal && closeBtn && iframe) {
    document.querySelectorAll('.youtube-thumbnail').forEach(thumbnail => {
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        const videoId = this.dataset.videoId;
        const downloadId = this.dataset.downloadId;

        // 增加下載數量
        const csrfToken = document.querySelector('meta[name="csrf-token"]');
        if (csrfToken && downloadId) {
          fetch(`/downloads/${downloadId}/increment_download_count`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken.content
            }
          }).catch(error => console.error('Error incrementing download count:', error));
        }

        if (videoId) {
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
          modal.style.display = 'block';
        }
      });
    });

    closeBtn.addEventListener('click', function() {
      modal.style.display = 'none';
      iframe.src = '';
    });

    window.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
        iframe.src = '';
      }
    });
  }

  $('a[href="#downloadFormAnchor"]').on('click', function (e) {
    const target = $('#downloadFormAnchor');
    if (target.length) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 80
      }, 400);
    }
  });
});

